import { render, staticRenderFns } from "./coTransferList.vue?vue&type=template&id=7edec40a&scoped=true"
import script from "./coTransferList.vue?vue&type=script&lang=js"
export * from "./coTransferList.vue?vue&type=script&lang=js"
import style0 from "./coTransferList.vue?vue&type=style&index=0&id=7edec40a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edec40a",
  null
  
)

export default component.exports